import classNames from "classnames/bind";
import React from "react";
import { InlineLoader } from "../InlineLoader";
import { Pill } from "../Pill";
import { PillProps } from "../Pill/types";
import styles from "./StatusPanel.module.scss";
import StatusPanelItem from "./StatusPanelItem";

const cx = classNames.bind(styles);

type StatusPanelProps = {
  data: Array<{ label: any; value: any }>;
  statusText: string;
  statusVariant: PillProps["variant"];
  isLoading?: boolean;
  isFluidY?: boolean;
};

const StatusPanel = ({
  data = [],
  statusText,
  statusVariant,
  isLoading,
  isFluidY = true,
}: StatusPanelProps) => {
  const loaderData: StatusPanelProps["data"] = [
    {
      label: (
        <InlineLoader
          height="14px"
          width="50%"
        />
      ),
      value: <InlineLoader height="14px" />,
    },
    {
      label: (
        <InlineLoader
          height="14px"
          width="50%"
        />
      ),
      value: <InlineLoader height="14px" />,
    },
  ];

  return (
    <section className={cx("panel", { isFluidY })}>
      {statusVariant && (
        <div className={cx("statusContainer", statusVariant)}>
          <Pill
            variant={statusVariant}
            hasBackgroundColor={false}
            hasDot={true}
          >
            {isLoading ? (
              <InlineLoader
                height="12px"
                width="50px"
              />
            ) : (
              statusText
            )}
          </Pill>
        </div>
      )}
      <div className={cx("body")}>
        {(isLoading ? loaderData : data).map((item, index) => (
          <StatusPanelItem
            key={index}
            item={item}
          />
        ))}
      </div>
    </section>
  );
};

export default StatusPanel;
